"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptInvite = exports.sendInvite = exports.deleteRequest = exports.verifyRequest = exports.verifyEmail = exports.signupReject = exports.signupAccept = exports.signup = exports.getRequests = exports.GET_REQUESTS = void 0;

var _auth = require("./auth");

var _avlComponents = require("@availabs/avl-components");

var _users = require("./users");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GET_REQUESTS = "AMS::GET_REQUESTS";
exports.GET_REQUESTS = GET_REQUESTS;

var getRequests = function getRequests() {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/requests/byProject"), {
        token: token,
        project_name: _utils.Config.PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(_objectSpread({
            type: GET_REQUESTS
          }, res));

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    }

    return Promise.resolve();
  };
};

exports.getRequests = getRequests;

var signup = function signup(email) {
  var addToGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/signup/request"), {
      email: email,
      addToGroup: addToGroup,
      project: _utils.Config.PROJECT_NAME,
      host: _utils.Config.CLIENT_HOST,
      url: addToGroup ? "/auth/verify-request" : "/auth/verify-email"
    }).then(function (res) {
      if (res.error) {
        return dispatch((0, _avlComponents.sendSystemMessage)(res.error, {
          type: 'Danger'
        }));
      } else {
        if (res.user) {
          dispatch((0, _auth.receiveAuthResponse)(res.user));
        }

        return dispatch((0, _avlComponents.sendSystemMessage)(res.message));
      }
    })["catch"](function (err) {
      return console.log('err', err);
    });
  };
};

exports.signup = signup;

var signupAccept = function signupAccept(user_email, group_name) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/signup/accept"), {
        group_name: group_name,
        user_email: user_email,
        token: token,
        project_name: _utils.Config.PROJECT_NAME,
        host: _utils.Config.CLIENT_HOST,
        url: "/auth/set-password"
      }).then(function (res) {
        if (res.error) {
          return dispatch((0, _avlComponents.sendSystemMessage)(res.error, {
            type: 'Danger'
          }));
        } else {
          dispatch(getRequests());
          dispatch((0, _users.getUsers)());
          return dispatch((0, _avlComponents.sendSystemMessage)(res.message));
        }
      });
    }

    return Promise.resolve();
  };
};

exports.signupAccept = signupAccept;

var signupReject = function signupReject(_ref) {
  var user_email = _ref.user_email,
      project_name = _ref.project_name;
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/signup/reject"), {
        token: token,
        user_email: user_email,
        project_name: project_name
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getRequests());
          dispatch((0, _users.getUsers)());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    }

    return Promise.resolve();
  };
};

exports.signupReject = signupReject;

var verifyEmail = function verifyEmail(token) {
  return function (dispatch) {
    return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/email/verify"), {
      token: token
    }).then(function (res) {
      return {
        dispatch: dispatch,
        res: res,
        sendSystemMessage: _avlComponents.sendSystemMessage
      };
    });
  };
};

exports.verifyEmail = verifyEmail;

var verifyRequest = function verifyRequest(token, password) {
  return function (dispatch) {
    return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/signup/request/verify"), {
      token: token,
      password: password
    }).then(function (res) {
      if (res.error) {
        return dispatch((0, _avlComponents.sendSystemMessage)(res.error, {
          type: 'Danger'
        }));
      } else {
        dispatch((0, _avlComponents.sendSystemMessage)(res.message));
        return dispatch((0, _auth.receiveAuthResponse)(res.user));
      }
    });
  };
};

exports.verifyRequest = verifyRequest;

var deleteRequest = function deleteRequest(request) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/signup/delete"), {
        token: token,
        user_email: request.user_email,
        project_name: request.project_name
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getRequests());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    }

    return Promise.resolve();
  };
};

exports.deleteRequest = deleteRequest;

var sendInvite = function sendInvite(user_email, group_name) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/invite"), {
        token: token,
        user_email: user_email,
        group_name: group_name,
        project_name: _utils.Config.PROJECT_NAME,
        host: _utils.Config.CLIENT_HOST,
        url: "/auth/accept-invite"
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getRequests());
          dispatch((0, _avlComponents.sendSystemMessage)(res.message));
        }
      });
    }

    return Promise.resolve();
  };
};

exports.sendInvite = sendInvite;

var acceptInvite = function acceptInvite(token, password) {
  return function (dispatch) {
    return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/invite/accept"), {
      token: token,
      password: password
    }).then(function (res) {
      if (res.error) {
        dispatch((0, _auth.auth)());
        return dispatch((0, _avlComponents.sendSystemMessage)(res.error, {
          type: 'Danger'
        }));
      } else {
        dispatch((0, _avlComponents.sendSystemMessage)(res.message));
        return dispatch((0, _auth.receiveAuthResponse)(res.user));
      }
    });
  };
};

exports.acceptInvite = acceptInvite;